var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.75 352H128V416H511.5L511.75 352ZM128 512H512V448H128.125L128 512ZM128 320H511.834L512 256H128V320ZM610.5 117L338.375 3.625C332.5 1.5 326.25 0.25 320 0C313.625 0.25 307.375 1.375 301.5 3.625L29.5 117C11.625 124.5 0 141.875 0 161.25V496C0 504.875 7.125 512 16 512H80C88.875 512 96 504.875 96 496L95.375 256C95.375 238.375 110 224 128 224H511.375C529.375 224 544 238.375 544 256V496C544 504.875 551.125 512 560 512H624C632.875 512 640 504.875 640 496V161.25C640 141.875 628.375 124.5 610.5 117Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.854eb4a102c761aaab6befbe187ce437.svg";
export { ForwardRef as ReactComponent };